module.exports = __webpack_public_path__ + "img/03.5bd55fc1.png";